import React, { useEffect } from 'react';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import TechStack from './components/TechStack';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealAll = () => {
      document
        .querySelectorAll('[data-reveal]')
        .forEach((el) => el.setAttribute('data-reveal', 'in'));
    };

    if (prefersReducedMotion) {
      revealAll();

      const mo = new MutationObserver(() => revealAll());
      mo.observe(document.body, { childList: true, subtree: true });
      return () => mo.disconnect();
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-reveal', 'in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    const observed = new WeakSet();

    const observeNewTargets = () => {
      document.querySelectorAll('[data-reveal="out"]').forEach((el) => {
        if (observed.has(el)) return;
        observed.add(el);
        observer.observe(el);
      });
    };

    observeNewTargets();

    const mutationObserver = new MutationObserver(() => observeNewTargets());
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      mutationObserver.disconnect();
      observer.disconnect();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App">
        <a
          href="#main"
          className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:rounded-none focus:border focus:border-foreground focus:bg-foreground focus:px-4 focus:py-2 focus:text-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
        >
          Skip to content
        </a>
        <Header />

        <main id="main" tabIndex={-1} className="outline-none">
          <Hero />
          <About />
          <Services />
          <TechStack />
          <Experience />
          <Projects />
          <Contact />
        </main>

        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
